var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"cockpitLayoutWrapper"}},[_c('the-sidebar',{staticClass:"sidebar-visible",attrs:{"id":"cockpitSidebar"}}),_vm._v(" "),_c('div',{attrs:{"id":"cockpitContent"}},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }